import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useGetSettings from './useGetSettings';

const useSetSettings = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const { getSettings } = useGetSettings();

    const onSettingInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onSettingInfoSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        callbackFn();
        getSettings();
    };

    const setSetting = (data: any, callbackFn: () => void) => {
        const url: HttpConfig = {
            url: `api/v1/company/settings/update`,
            method: 'patch',
            data: data,
        };

        return request(url, onSettingInfoSuccess(callbackFn), setLoading, onSettingInfoError);
    };

    return { setSetting, loading };
};

export default useSetSettings;
